import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { FaCheckCircle, FaCreditCard } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import StudentService from '../../services/studentService';
import { toast } from 'react-toastify';
import Header from '../../components/common/Header';
import PaymentModal from './PaymentModal'; // Import PaymentModal

const Payments = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    loadCourses();
  }, []);

  const loadCourses = async () => {
    try {
      setLoading(true);
      const response = await StudentService.getStudentCourses(user.id);
      setCourses(response.data || []);
    } catch (error) {
      toast.error('Failed to load courses');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentClick = (course) => {
    console.log('💰 Payment button clicked for course:', course);
    setSelectedCourse(course);
    setShowPaymentModal(true);
  };

  const handlePaymentSuccess = () => {
    console.log('✅ Payment successful, refreshing courses');
    setShowPaymentModal(false);
    setSelectedCourse(null);
    loadCourses(); // Refresh the course list
    toast.success('Payment completed successfully');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(amount || 0);
  };

  const pendingCourses = courses.filter((c) => c.due_amount > 0);

  if (loading) {
    return (
      <div>
        <Header />
        <div className="container-fluid p-5 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (pendingCourses.length === 0) {
    return (
      <div>
        <Header />
        <div className="container-fluid p-4">
          <Alert variant="success">
            <FaCheckCircle className="me-2" />
            You have no pending payments. All courses are fully paid!
          </Alert>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="container-fluid p-4">
        <h2 className="mb-4">Pending Payments</h2>
        <Row>
          {pendingCourses.map((course) => (
            <Col md={6} className="mb-3" key={course.course_id}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Row>
                    <Col md={8}>
                      <h6>{course.course_name}</h6>
                      <small className="text-muted">
                        Total: {formatCurrency(course.total_fees)} | Paid: {formatCurrency(course.paid_amount)}
                      </small>
                    </Col>
                    <Col md={4} className="text-end">
                      <h5 className="text-danger">{formatCurrency(course.due_amount)}</h5>
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <Button
                      variant="success"
                      size="sm"
                      className="w-100"
                      onClick={() => handlePaymentClick(course)}
                    >
                      <FaCreditCard className="me-2" /> Pay {formatCurrency(course.due_amount)}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Payment Modal */}
      <PaymentModal
        show={showPaymentModal}
        onHide={() => {
          console.log('🔒 Payment modal closed');
          setShowPaymentModal(false);
          setSelectedCourse(null);
        }}
        course={selectedCourse}
        studentId={user?.id}
        onSuccess={handlePaymentSuccess}
      />
    </div>
  );
};

export default Payments;